import {ReactNode} from 'react';

import {
  BaseContextT,
  createAppContext,
  createAppHook,
  createAppProvider,
  createProviderConfig,
  useBaseContext,
} from '@/providers/components/baseProvider';

// Config
const {table, columns, statsView} = createProviderConfig({
  table: 'Product',
  statsView: 'product_stats',
});

type TableT = typeof table;
type ColumnsT = typeof columns;
type StatsViewT = typeof statsView;
type CustomContextT = Record<string, unknown>;
// Context
type ProductContextT = BaseContextT<TableT, StatsViewT, ColumnsT, CustomContextT>;
const ProductsContext = createAppContext<ProductContextT>(table);

// Provider
const ContextProvider = ({children}: {children: ReactNode}) => {
  const baseContext = useBaseContext<TableT, ColumnsT, StatsViewT>();

  // Custom state, functions, etc...

  return (
    <ProductsContext.Provider
      value={{
        ...baseContext,
        // ...add custom stuff here...
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
};

// Add this to the AppProviders.tsx file
export const ProductsProvider = createAppProvider({
  table,
  columns,
  statsView,
  ContextProvider,
});

/*******************************************************************
 * Hook
 *******************************************************************/
export const useProducts = createAppHook<TableT, StatsViewT, ColumnsT, CustomContextT>(ProductsContext);
